<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 40%;
  border-radius: 20px;
  padding: 0 100px;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.info-input{
   border: solid 1px #d2d4d6;
   border-radius: 30px;
   padding: 10px 15px;
   width: 100%;
   height: 40px;
   -moz-appearance: textfield;
}
.privacy-policy{
   cursor: pointer;
}
.privacy-policy:hover{
   text-decoration: underline;
}
@media(max-width: 1000px){
.card{
  padding: 0 20px;
}
}
</style>
<template>
    <div>
            <div class="js-scrollbar u-sidebar__body container" v-loading.fullscreen.lock="fullscreenLoading">
                <div class="row">
                    <div class="col-md-3"></div>
                        <div class="col-md-6 pr-4 pl-2 mt-4" align="center">
                            <div class="u-sidebar__content u-header-sidebar__content card" :style="{'width': '100%'}">
                                <form class="js-validate" @submit.prevent="register">
                                    <!-- Login -->
                                    <div id="login" data-target-group="idForm">
                                        <!-- Title -->
                                        <div class=" mt-5">
                                            <!-- <a class="btn btn-block btn-sm btn-soft-facebook transition-3d-hover mr-1" href="#">
                                              <span class="fab fa-facebook-square mr-1"></span>
                                              Facebook - ээр нэвтрэх
                                            </a> -->
                                            <!-- <el-button @click="logInWithFacebook" :disabled="facebookButton.disabled" type="primary" style="width: 100%; background: #4267B2;" :loading="facebookButton.load">
                                                <span class="fab fa-facebook-square mr-1"></span>
                                                {{facebookButton.text}}
                                            </el-button> -->

                                            <button class="transition-3d-hover" type="button" style="width: 100%;background-color: #1877f2;border-radius: 20px;border:none;margin-top: 5px;padding: 3px 0 9px 0;"  @click="logInWithFacebook"><img src="@/assets/images/login/facebook.png" style="width: 30px;height: auto;"></button>
                                            <button class="transition-3d-hover" type="button" style="width: 100%;background-color: #fffffc;border-radius: 20px;border:solid 1px #f24144;margin: 10px 0;padding: 2px 0 2px 0;" @click="googleLogin"><img src="@/assets/images/login/google.png" style="width: 35px;height: auto;" ></button>
                                        </div>

                                        <div class="text-center mt-2">
                                            <span class="u-divider--text mb-4 mt-4 font-size-12">ЭСВЭЛ</span>
                                        </div>
                                        
                                        <div class="form-group">
                                                <div class="js-form-message js-focus-state">
                                                    <label class="sr-only" for="name">Нэр</label>
                                                    <div class="input-group">
                                                        <input type="text" maxlength="100" class="info-input" name="name" id="name" placeholder="Хэрэглэгчийн нэр" aria-label="Name" aria-describedby="nameLabel" required v-model="user.name"
                                                        data-msg="Нэр оруулна уу."
                                                        data-error-class="u-has-error"
                                                        data-success-class="u-has-success">
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- End Input -->

                                            <!-- Form Group -->
                                            <div class="form-group">
                                                <div class="js-form-message js-focus-state">
                                                    <label class="sr-only" for="signupEmail">Имэйл</label>
                                                    <div class="input-group">
                                                        <input type="email" class="info-input" name="email" id="signupEmail" placeholder="И-мэйл хаяг" aria-label="Email" aria-describedby="signupEmailLabel" required v-model="user.email"
                                                        data-msg="И-мэйл хаягаа оруулна уу."
                                                        data-error-class="u-has-error"
                                                        data-success-class="u-has-success">
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- End Input -->
                                            <div class="form-group">
                                                <div class="js-form-message js-focus-state">
                                                    <label class="sr-only" for="signupEmail">Утасны дугаар</label>
                                                    <div class="input-group">
                                                        <input type="text" class="info-input" pattern="[0-9]{8}" name="phone" id="signupPhone" placeholder="Утасны дугаар" aria-label="phone" aria-describedby="signupEmailLabel" required v-model="user.phone"
                                                        data-msg="Утасны дугаараа оруулна уу."
                                                        data-error-class="u-has-error"
                                                        data-success-class="u-has-success">
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Form Group -->
                                            <div class="form-group">
                                                <div class="js-form-message js-focus-state">
                                                    <label class="sr-only" for="signupPassword">Password</label>
                                                    <div class="input-group">
                                                        <input type="password" class="info-input" name="password" id="signupPassword" placeholder="Нууц үг" aria-label="Password" aria-describedby="signupPasswordLabel" required v-model="user.password"
                                                        data-msg="Буруу нууц үг. Дахин оролдоно уу."
                                                        data-error-class="u-has-error"
                                                        data-success-class="u-has-success" minlength="8">
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- End Input -->

                                            <!-- Form Group -->
                                            <div class="form-group">
                                                <div class="js-form-message js-focus-state">
                                                <label class="sr-only" for="signupConfirmPassword">Confirm Password</label>
                                                    <div class="input-group">
                                                    <input type="password" class="info-input" name="confirmPassword" id="signupConfirmPassword" placeholder="Давтан нууц үг" aria-label="Confirm Password" aria-describedby="signupConfirmPasswordLabel" required v-model="user.rePassword"
                                                    data-msg="Нууц үг тохирсонгүй."
                                                    data-error-class="u-has-error"
                                                    data-success-class="u-has-success">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex ml-4 mb-2"> 
                                            <input type="checkbox" class="mr-2" v-model="checked">
                                            <span class="font-size-11"> Би энэхүү <router-link to="/policy-two"><a href="#" class="ikea-family-price privacy-policy">Үйлчилгээний нөхцөл</a></router-link> -ийг зөвшөөрч байна</span>
                                        </div>
                                        <div class="mb-2">
                                            <button type="submit" class="btn btn-block btn-sm btn-primary-dark-w transition-3d-hover">Бүртгүүлэх</button>
                                        </div>

                                        <div class="text-center mb-4">
                                            <router-link class="js-animation-link middle text-dark" to="/login"
                                               data-target="#signup"
                                               data-link-group="idForm"
                                               data-animation-in="slideInUp"><span class="ikea-family-price privacy-policy">Нэвтрэх</span>
                                            </router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                <div class="col-md-3"></div>
            </div>
        </div>
        <Brands />
    </div>
</template>
<script>
import Brands from "@/components/brands";
export default {
    components: {
        Brands
    },
    data() {
        return {
            fullscreenLoading: false,
            checked:false,
            facebookButton: {
                text: 'Facebook',
                disabled: false,
                load: false
            },
            user: {
                name: '',
                email: '',
                password: '',
                rePassword: '',
                phone: ''
            },
            googleButton:{
                text:'Google',
                disabled:false,
                load:false,
            }
        }
    },
    async mounted() {
        await this.loadFacebookSDK(document, "script", "login-facebook-jssdk");
        await this.initFacebook();
        this.$emit('getJquery');
        window.addEventListener('message', (event) => {
       if (event.origin !== this.$appUrl) return;
                    this.$notify({
                        title: 'Амжилттай',
                        message: `Системд амжилттай нэвтэрлээ`,
                        type: 'success'
                    });
                    localStorage.token =event.data.token;
                    localStorage.user = JSON.stringify(event.data.data);
                    this.$router.push('/home');
      });
    },
    beforeRouteLeave (to, from , next) {
      if(to.name == 'login') {
          next();
      } else {
          window.location.href = window.location.protocol + '//' + window.location.host + '/' + to.name;  
      }
    },
    methods: {
        register() {
            if(this.checked){
                if(this.user.password === this.user.rePassword && this.checked) {
                this.fullscreenLoading = true;
                let rts = this;
                rts.$axios({
                    method: 'POST',
                    url: rts.$appUrl + '/api/user/register',
                    headers: {},
                    data: {
                        user: this.user
                    }
                }).then(data => {
                    rts.fullscreenLoading = false;
                    if(data.data.result == 'success') {
                        this.$notify({
                            title: 'Амжилттай',
                            message: `Бүртгэгдлээ. Имейлээ шалгана уу.`,
                            type: 'success'
                        });
                        rts.$router.push('/login');
                    } else if(data.data.result == 'somewrong') {
                        this.$notify({
                            title: 'Амжилтгүй',
                            message: `Уучлаарай. алдаа гарлаа дахин оролдоно уу`,
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: 'Амжилтгүй',
                            message: `Уучлаарай. Цахим хаяг бүртгэлтэй байна`,
                            type: 'error'
                        });
                    }
                }).catch(err => {
                    console.log(err);
                    rts.fullscreenLoading = false;
                });
            } else {
                this.$notify({
                    title: 'Амжилтгүй',
                    message: `Уучлаарай. Нууц үг тохирсонгүй`,
                    type: 'error'
                });
            }
            }else{
                this.$notify({
                    title: 'Амжилтгүй',
                    message: `Үйлчилгээний нөхцөлийг зөвшөөрнө үү.`,
                    type: 'error'
                });
            }
        },
        async logInWithFacebook() {
            let rts = this;
            this.facebookButton.text = 'Түр хүлээнэ үү...';
            this.facebookButton.disabled = true;
            this.facebookButton.load = true;
            const FB = window.FB;
            FB.login(function(response) {
                if (response.authResponse) {
                    rts.$axios({
                        method: 'GET',
                        url: `https://graph.facebook.com/v21.0/me?fields=id%2Cname%2Cemail%2Cpicture&access_token=${response.authResponse.accessToken}`,
                    }).then(function(data) {
                        rts.withFacebookLogin(data);
                    }).catch(error => {
                            rts.facebookButton.text = 'Facebook -ээр нэвтрэх';
                            rts.facebookButton.load = false;
                            rts.facebookButton.disabled = false;
                            this.facebookButton.load = false;
                        rts.$notify({
                            title: 'Амжилтгүй',
                            message: `Уучлаарай. Шаардлагатай талбарууд татагдсангүй.`,
                            type: 'error'
                        });
                    })
                } else {
                    rts.facebookButton.text = 'Facebook';
                    rts.facebookButton.disabled = false;
                    this.facebookButton.load = false;
                }
            },{scope: 'public_profile,email'});
            
        },
        withFacebookLogin(data) {
        let rts = this;
        rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/user/facebook-login',
                headers: {},
                data: {
                    user: data.data
                }
                }).then(data => {
                if(data.data.result === 'success') {
                    rts.$notify({
                        title: 'Амжилттай',
                        message: `Системд амжилттай нэвтэрлээ`,
                        type: 'success'
                    });

                    rts.facebookButton.text = 'Facebook';
                    rts.facebookButton.disabled = true;
                    this.facebookButton.load = false;
                    localStorage.token = data.data.token;
                    localStorage.user = JSON.stringify(data.data.data);
                    rts.$router.push('/home');
                }
        });
        },
        async initFacebook() {
            window.fbAsyncInit = function() {
                window.FB.init({
                    appId: "1634408070838818", //You will need to change this
                    cookie: true, // This is important, it's not enabled by default
                    version: "v21.0"
                });
            };
            return true;
        },
        async loadFacebookSDK(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
                
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
            return true;
        },
        googleLogin(){
                  // Шинэ цонхонд нэвтрэлтийн хуудас нээх
                 const newWindow = window.open(`${this.$appUrl}/api/user/google-login`, '_blank', 'width=500,height=600');
      
                // Цонхны хаалт эсвэл хариу хүлээхийг хүсвэл цаашид код нэмж болно
                 if (newWindow) {
                newWindow.focus();
                 }
            // var rts=this;
            // rts.googleButton.disabled=true;
            // rts.googleButton.load=true;
            // this.$axios({
            //     method:'get',
            //     url:rts.$appUrl+'/google-login'
            // }).then(data=>{
            //     console.log(data);
            // })
        }
    }
}
</script>